<template>
    <div>
        <vx-navbar color="light" class="app-navbar mb-6 sm:mb-12">
            <template v-slot:left>
                <vx-navbar-action href="/kiosk/teams" class="hide-action-icon" :marker="false">
                    <navbar-logo></navbar-logo>
                    <span class="hidden text-base text-slate-800 sm:block">Kiosk Mode</span>
                </vx-navbar-action>
            </template>

            <template v-slot:right>
                <vx-button href="/" size="sm" color="muted-dark">
                    Exit Kiosk Mode
                    <font-awesome-icon widthAuto :icon="faPersonToDoor" class="text-sm"></font-awesome-icon>
                </vx-button>
            </template>

            <vx-navbar-action
                color="light"
                :icon="faUsers"
                href="/kiosk/teams"
                class="hide-action-icon"
                :active="activeNav === 'teams'"
            >
                <span>Teams</span>
            </vx-navbar-action>
            <vx-navbar-action
                color="light"
                :icon="faBuildingFlag"
                href="/kiosk/org-units"
                class="hide-action-icon"
                :active="activeNav === 'ous'"
            >
                <span>OUs</span>
            </vx-navbar-action>
            <vx-navbar-action
                color="light"
                :icon="faGrid2Plus"
                href="/kiosk/groups"
                class="hide-action-icon"
                :active="activeNav === 'groups'"
            >
                <span>Groups</span>
            </vx-navbar-action>
            <vx-navbar-action
                color="light"
                :icon="faUser"
                href="/kiosk/users"
                class="hide-action-icon"
                :active="activeNav === 'users'"
            >
                <span>Users</span>
            </vx-navbar-action>
            <vx-navbar-action
                color="light"
                :icon="faClone"
                href="/kiosk/cloning"
                class="hide-action-icon"
                :active="activeNav === 'cloning'"
            >
                <span>Cloning</span>
            </vx-navbar-action>
            <vx-navbar-action
                color="light"
                :icon="faArrowRightArrowLeft"
                href="/kiosk/migrations"
                class="hide-action-icon"
                :active="activeNav === 'migrations'"
            >
                <span>Migrations</span>
            </vx-navbar-action>
        </vx-navbar>
    </div>
    <div data-test="kiosk-layout-container" :class="containerClasses">
        <slot></slot>
    </div>
</template>

<script setup>
import {
    faArrowRightArrowLeft,
    faBuildingFlag,
    faClone,
    faGrid2Plus,
    faPersonToDoor,
    faUser,
    faUsers,
} from '@fortawesome/pro-solid-svg-icons';
import { VxButton, VxNavbar, VxNavbarAction } from '@voxie/frontend-components';
import { match } from 'path-to-regexp';
import { computed } from 'vue';
import NavbarLogo from '~/components/navbar/NavbarLogo.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const props = defineProps({
    formContainer: {
        type: Boolean,
        default: false,
    },
});

const containerClasses = computed(() =>
    props.formContainer
        ? 'container mx-auto px-3 pb-64 2xl:px-0 max-w-(--breakpoint-xl)'
        : 'space-y-8 md:space-y-12 pb-32 px-4 sm:px-6 md:px-8'
);

// Order matters: first match wins. Specific nested routes must precede
// their catch-all parent. "imports" must precede ":groupId" because
// path-to-regexp would match "imports" as a :groupId param value.
const navRoutes = [
    { matcher: match('/kiosk/teams/:team/org-units{/*path}'), nav: 'ous' },
    { matcher: match('/kiosk/teams/:team/groups/imports{/*path}'), nav: 'teams' },
    { matcher: match('/kiosk/teams/:team/groups/:groupId{/*path}'), nav: 'groups' },
    { matcher: match('/kiosk/teams{/*path}'), nav: 'teams' },
    { matcher: match('/kiosk/org-units{/*path}'), nav: 'ous' },
    { matcher: match('/kiosk/groups{/*path}'), nav: 'groups' },
    { matcher: match('/kiosk/users{/*path}'), nav: 'users' },
    { matcher: match('/kiosk/cloning{/*path}'), nav: 'cloning' },
    { matcher: match('/kiosk/migrations{/*path}'), nav: 'migrations' },
];

const activeNav = navRoutes.find((route) => route.matcher(window.location.pathname))?.nav ?? null;
</script>
